var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('agro-generic-card',{staticClass:"card-processing-count ",attrs:{"title":("" + (_vm.$t('farms-home.agro-cards.processing'))),"icon":"hour-glass","color":"#00FCA1","value":_vm.count,"isLoading":_vm.isLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }